/**
 * Helpers for the opt-in flat (Edit-by-page) review layout.
 * The review-edit trip (leave review → schema page → return) lives in
 * reviewEditTrip.js.
 */

export const FLAT_REVIEW_SUCCESS_MESSAGE = 'Your information has been updated';
export const FLAT_REVIEW_SUCCESS_BODY_BEFORE =
  'You can submit now, or keep reviewing. ';
export const FLAT_REVIEW_SUCCESS_JUMP_TEXT = 'Jump to the statement of truth';
export const FLAT_REVIEW_SUCCESS_BODY_AFTER = " when you're ready to submit.";
export const FLAT_REVIEW_CHANGED_MESSAGE =
  'Some information has changed. Please review.';

/**
 * SchemaForm/widget flags for the flat review page. Lives on
 * formContext.renderOptions so we don't keep stacking keys on formContext.
 */
export const FLAT_REVIEW_RENDER_OPTIONS = {
  spellOutDates: true,
  hideEmptyOptional: true,
  emptyRequiredLabel: 'Not provided',
  hideFieldDescription: true,
};

/**
 * True when the platform flag is on, this form asked for the flat review page,
 * and any required per-form toggle is on. Accordion remains the default.
 *
 * @param {Object} [formConfig]
 * @param {Object} [featureToggles]
 * @returns {boolean}
 */
export function isFlatReviewEnabled(formConfig, featureToggles = {}) {
  if (!featureToggles.form_system_flat_review_page) {
    return false;
  }

  if (formConfig?.reviewPage?.style !== 'flat') {
    return false;
  }

  const toggleName = formConfig.reviewPage.toggle;
  if (!toggleName) {
    return true;
  }

  return Boolean(featureToggles[toggleName]);
}

/**
 * Focus target id for a schema section on the flat review page.
 *
 * @param {string} pageKey
 * @returns {string}
 */
export function flatReviewSectionId(pageKey) {
  return `flat-review-${pageKey}`;
}

/**
 * Stable id for chapter h2 headings (va-on-this-page).
 *
 * @param {string} text
 * @param {string} [fallback='section']
 * @returns {string}
 */
export function slugifyHeadingId(text, fallback = 'section') {
  const slug = String(text || fallback)
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');

  return slug || fallback;
}
